var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99253 21C9.25505 21.0022 9.50796 20.9013 9.6968 20.7189L17.7066 12.708C17.7994 12.6147 17.8729 12.5042 17.9229 12.3825C17.9738 12.2614 18 12.1314 18 12C18 11.8686 17.9738 11.7386 17.9229 11.6175C17.8729 11.4958 17.7994 11.3853 17.7066 11.292L9.6968 3.2811C9.50796 3.09869 9.25505 2.99776 8.99253 3.00004C8.73001 3.00232 8.47889 3.10763 8.29325 3.29329C8.10762 3.47896 8.00232 3.73011 8.00004 3.99267C7.99776 4.25522 8.09867 4.50817 8.28106 4.69703L15.583 12L14.5818 13.0014L8.28106 19.303C8.09867 19.4918 7.99776 19.7448 8.00004 20.0073C8.00232 20.2699 8.10762 20.521 8.29325 20.7067C8.47889 20.8924 8.73001 20.9977 8.99253 21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLg);
export default __webpack_public_path__ + "static/media/right-lg.661b69c6447800f14d23c16591776a2b.svg";
export { ForwardRef as ReactComponent };